import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useFacetData } from '~/context/common/FacetDataContext';
import FilterDrawer from './FilterDrawer';
import { Label } from './FiltersMenu.styles';
import useRangeUpdater from './hooks/useRangeUpdater';
import InputRangeSlider from './InputRangeSlider';

export default function SeatingCapacity() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const facetData = useFacetData();
  const { min: facetDataMin, max: facetDataMax } =
    facetData.seatingCapacity ?? {};
  const { min: appliedFiltersMin, max: appliedFiltersMax } =
    appliedFilters.seatingCapacity ?? {};

  const [rangeValues, setRangeValues] = useState([
    appliedFiltersMin ?? facetDataMin ?? 0,
    appliedFiltersMax ?? facetDataMax ?? 0
  ]);
  const onUpdate = useRangeUpdater({
    filterKey: 'seatingCapacity',
    max: facetDataMax,
    min: facetDataMin
  });

  useSubsequentEffect(() => {
    setRangeValues([
      appliedFiltersMin ?? facetDataMin ?? 0,
      appliedFiltersMax ?? facetDataMax ?? 0
    ]);
  }, [appliedFiltersMax, appliedFiltersMin, facetDataMax, facetDataMin]);

  return (
    <FilterDrawer
      testId="facet-seating-capacity"
      facetContent={true}
      facetName="Seating Capacity"
    >
      <Label>Seats</Label>
      <InputRangeSlider
        data-analytics-id="adjust-seating-capacity-range"
        format="number"
        idPrefix="seating"
        min={facetDataMin}
        max={facetDataMax}
        thumbBehavior="slide-through"
        value={rangeValues}
        onValueChange={value => {
          setRangeValues(value);
        }}
        onValueCommit={value => {
          onUpdate(value);
        }}
      />
    </FilterDrawer>
  );
}
